module.exports = __webpack_public_path__ + "static/media/host-command-arrow-down.8a50e8f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/host-command-arrow-down.svg
// module id = ./src/assets/images/host-command-arrow-down.svg
// module chunks = 0